var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5625,
    y: 0.5,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#CBD5E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8976 26.6V29.1C30.8986 29.3321 30.8511 29.5618 30.7581 29.7745C30.6651 29.9871 30.5287 30.178 30.3577 30.3349C30.1867 30.4918 29.9848 30.6113 29.7649 30.6856C29.5451 30.76 29.3121 30.7876 29.081 30.7667C26.5167 30.4881 24.0535 29.6118 21.8893 28.2084C19.8758 26.9289 18.1688 25.2219 16.8893 23.2084C15.481 21.0344 14.6045 18.5592 14.331 15.9834C14.3102 15.7529 14.3375 15.5207 14.4114 15.3014C14.4853 15.0821 14.604 14.8806 14.76 14.7097C14.916 14.5388 15.1058 14.4023 15.3175 14.3088C15.5291 14.2153 15.7579 14.1669 15.9893 14.1667H18.4893C18.8937 14.1627 19.2858 14.3059 19.5925 14.5697C19.8991 14.8334 20.0994 15.1996 20.156 15.6C20.2615 16.4001 20.4572 17.1856 20.7393 17.9417C20.8514 18.24 20.8757 18.5641 20.8092 18.8758C20.7428 19.1874 20.5884 19.4735 20.3643 19.7L19.306 20.7584C20.4923 22.8447 22.2197 24.5721 24.306 25.7584L25.3643 24.7C25.5909 24.476 25.8769 24.3216 26.1886 24.2551C26.5002 24.1887 26.8244 24.2129 27.1226 24.325C27.8787 24.6072 28.6643 24.8029 29.4643 24.9084C29.8691 24.9655 30.2388 25.1694 30.5031 25.4813C30.7674 25.7932 30.9078 26.1914 30.8976 26.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.977ad8974b7da943375bc557ada2d32a.svg";
export { ForwardRef as ReactComponent };